// Bilingual translations: Portuguese (PT-BR) and Spanish (ES)
export const translations = {
  pt: {
    brand: "PrimeForms",
    tagline: "USCIS · Self-Service",
    disclaimer_short: "Ferramenta tecnológica. Não é aconselhamento jurídico.",
    disclaimer_long:
      "Este é um sistema puramente tecnológico de preenchimento de formulários. Ele NÃO avalia casos, NÃO recomenda vistos, NÃO substitui assessoria legal. O usuário é o único responsável pela veracidade das informações e pelo envio do documento.",
    nav: {
      home: "Início",
      new_form: "Novo Formulário",
      dashboard: "Meus Formulários",
      advisor: "Qual formulário?",
      pricing: "Planos",
      admin: "Admin",
      about: "Sobre",
    },
    common: {
      next: "Próximo",
      back: "Voltar",
      save: "Salvar",
      cancel: "Cancelar",
      download: "Baixar PDF",
      preview: "Pré-visualizar",
      required: "Obrigatório",
      optional: "Opcional",
      loading: "Carregando…",
      submit: "Gerar PDF",
      review: "Revisar",
      start: "Começar",
      draft: "Rascunho",
      completed: "Completo",
      new: "Novo",
      view: "Ver",
      edit: "Editar",
      delete: "Excluir",
      confirm: "Confirmar",
      draft_restored: "Rascunho restaurado",
      discard_draft: "Descartar rascunho",
      autosaved: "Salvo automaticamente",
      edit_ssn_hint: "SSN já registrado. Deixe em branco para manter.",
      logout: "Sair",
    },
    packages: {
      overline: "Pacotes Combinados · USCIS",
      title: "Pacote AOS Combo",
      subtitle: "Crie múltiplos formulários relacionados de uma vez, compartilhando dados pessoais e endereço. Você preenche os campos específicos de cada formulário depois.",
      nav: "Pacotes",
      step_select: "Escolher Pacote",
      step_select_description: "Selecione qual combinação de formulários deseja criar.",
      step_principal: "Requerente Principal",
      step_dependents: "Dependentes",
      step_dependents_description: "Adicione cônjuge, filhos ou outros dependentes que também terão formulários gerados (I-485/I-765/I-131 para cada um).",
      no_dependents: "Nenhum dependente. Clique abaixo para adicionar cônjuge ou filhos.",
      add_dependent: "Adicionar dependente",
      dependent: "Dependente",
      dependent_incomplete: "Complete os dados do dependente",
      relationship: "Parentesco",
      forms_created: "formulários criados",
      roles: {
        principal: "Requerente Principal",
        spouse: "Cônjuge",
        child: "Filho(a)",
        parent: "Pai/Mãe",
      },
      create_cta: "Criar formulários",
      created_title: "Pacote criado",
      created_description: "Os formulários abaixo foram criados como rascunhos, com seus dados pessoais e endereço compartilhados. Clique em Editar para completar cada um.",
      created_success: "Formulários do pacote criados",
    },
    auth: {
      overline_login: "Entrar",
      login_title: "Acesse sua conta",
      login_subtitle: "Use seu email e senha para continuar.",
      overline_register: "Cadastro",
      register_title: "Crie sua conta",
      register_subtitle: "Comece a preencher seus formulários com segurança.",
      email: "Email",
      password: "Senha",
      name: "Nome",
      login_cta: "Entrar",
      register_cta: "Cadastrar",
      no_account: "Ainda não tem conta?",
      has_account: "Já tem conta?",
      welcome: "Bem-vindo(a)!",
      password_min: "A senha deve ter pelo menos 8 caracteres.",
    },
    checklist: {
      overline: "Checklist de Evidências",
      title: "Documentos Necessários",
      description: "Marque cada item conforme reúne. Salvo automaticamente no seu dispositivo.",
      progress: "Progresso",
      required_short: "obrigatórios",
    },
    landing: {
      overline: "USCIS · Self-Service",
      title_1: "Preencha formulários",
      title_2: "oficiais da USCIS",
      title_3: "com segurança.",
      subtitle:
        "Assistente passo-a-passo para formulários de imigração dos EUA. Você fornece os dados. Nós geramos o PDF. Você revisa, assina e envia. Simples assim.",
      cta_primary: "Iniciar preenchimento",
      cta_secondary: "Ver meus formulários",
      how_it_works: "Como funciona",
      step_1_title: "1. Aceite os termos",
      step_1_desc: "Concorde que esta é uma ferramenta tecnológica de preenchimento.",
      step_2_title: "2. Preencha os dados",
      step_2_desc: "Nome, endereço, formulário desejado e campos específicos.",
      step_3_title: "3. Baixe o PDF",
      step_3_desc: "Revise cada campo, assine à mão e envie ao USCIS.",
      not_doing_overline: "O que este sistema NÃO faz",
      not_doing_items: [
        "Não avalia elegibilidade",
        "Não recomenda vistos",
        "Não dá opinião jurídica",
        "Não analisa chances",
      ],
    },
    wizard: {
      step_consent: "Consentimento",
      step_personal: "Dados Pessoais",
      step_address: "Endereço",
      step_form: "Formulário",
      step_specific: "Campos Específicos",
      step_review: "Revisão",
      progress: "Etapa {current} de {total}",
    },
    consent: {
      title: "Termo de Consentimento",
      description:
        "Leia atentamente. Ao continuar, você declara que entende que esta é uma ferramenta tecnológica de preenchimento de formulários — não um serviço jurídico.",
      acknowledge:
        "Entendo que este sistema apenas preenche formulários com os dados que forneço. Sou o único responsável pela veracidade das informações, pela revisão do documento gerado, pela assinatura e pelo envio à USCIS. Este serviço NÃO oferece aconselhamento jurídico, NÃO avalia elegibilidade e NÃO substitui um advogado.",
      signature_label: "Assinatura Digital (nome completo)",
      signature_placeholder: "Digite seu nome completo",
      signature_help: "Ao digitar seu nome você confirma o consentimento acima.",
    },
    personal: {
      title: "Dados Pessoais",
      description: "Informações básicas de identificação.",
      family_name: "Sobrenome (Family Name)",
      given_name: "Nome (Given Name)",
      middle_name: "Nome do meio",
      date_of_birth: "Data de nascimento",
      gender: "Gênero",
      gender_options: { MALE: "Masculino", FEMALE: "Feminino", OTHER: "Outro" },
      ssn: "Social Security Number (SSN)",
      ssn_help: "9 dígitos. Criptografado antes de armazenar.",
      a_number: "A-Number (Alien Registration)",
      a_number_help: "9 dígitos, se você tiver.",
      email: "E-mail",
      phone: "Telefone",
    },
    address: {
      title: "Endereço",
      description: "Endereço residencial ou de correspondência.",
      street: "Endereço (rua e número)",
      apartment: "Apto/Unidade",
      city: "Cidade",
      state: "Estado/Província",
      zip: "CEP / ZIP",
      country: "País",
    },
    form_selection: {
      title: "Selecione o Formulário",
      description: "Escolha qual formulário oficial da USCIS você deseja preencher.",
      categories: "Categorias:",
    },
    form_specific: {
      title: "Campos Específicos",
      description: "Informações específicas do formulário selecionado.",
    },
    review: {
      title: "Revisão e Validação",
      description:
        "Confira todos os dados. O sistema executa uma verificação técnica de completude — não uma análise jurídica.",
      filled: "Campos preenchidos",
      missing: "Campos obrigatórios faltando",
      warnings: "Avisos técnicos",
      valid: "Todos os campos obrigatórios foram preenchidos.",
      generate: "Gerar PDF",
      generating: "Gerando…",
    },
    success: {
      title: "PDF gerado com sucesso",
      description:
        "Revise cada campo do PDF antes de imprimir, assinar e enviar à USCIS. Você é o único responsável pelo conteúdo.",
      download: "Baixar PDF",
      new_form: "Novo formulário",
      dashboard: "Ir ao painel",
    },
    dashboard: {
      title: "Meus Formulários",
      description: "Todos os formulários preenchidos por você neste dispositivo.",
      empty: "Nenhum formulário ainda. Comece pelo primeiro.",
      create: "Criar novo formulário",
      column_form: "Formulário",
      column_status: "Status",
      column_updated: "Atualizado",
      column_actions: "Ações",
    },
  },
  es: {
    brand: "PrimeForms",
    tagline: "USCIS · Autoservicio",
    disclaimer_short: "Herramienta tecnológica. No es asesoría legal.",
    disclaimer_long:
      "Este es un sistema puramente tecnológico de llenado de formularios. NO evalúa casos, NO recomienda visas, NO sustituye asesoría legal. El usuario es el único responsable de la veracidad de la información y del envío del documento.",
    nav: {
      home: "Inicio",
      new_form: "Nuevo Formulario",
      dashboard: "Mis Formularios",
      advisor: "¿Qué formulario?",
      pricing: "Planes",
      admin: "Admin",
      about: "Acerca de",
    },
    common: {
      next: "Siguiente",
      back: "Atrás",
      save: "Guardar",
      cancel: "Cancelar",
      download: "Descargar PDF",
      preview: "Vista previa",
      required: "Obligatorio",
      optional: "Opcional",
      loading: "Cargando…",
      submit: "Generar PDF",
      review: "Revisar",
      start: "Comenzar",
      draft: "Borrador",
      completed: "Completo",
      new: "Nuevo",
      view: "Ver",
      edit: "Editar",
      delete: "Eliminar",
      confirm: "Confirmar",
      draft_restored: "Borrador restaurado",
      discard_draft: "Descartar borrador",
      autosaved: "Guardado automáticamente",
      edit_ssn_hint: "SSN ya registrado. Déjelo en blanco para mantenerlo.",
      logout: "Salir",
    },
    packages: {
      overline: "Paquetes Combinados · USCIS",
      title: "Paquete AOS Combo",
      subtitle: "Cree múltiples formularios relacionados de una vez, compartiendo datos personales y dirección. Complete los campos específicos de cada formulario luego.",
      nav: "Paquetes",
      step_select: "Elegir Paquete",
      step_select_description: "Seleccione qué combinación de formularios desea crear.",
      step_principal: "Solicitante Principal",
      step_dependents: "Dependientes",
      step_dependents_description: "Agregue cónyuge, hijos u otros dependientes que también tendrán formularios generados (I-485/I-765/I-131 para cada uno).",
      no_dependents: "Ningún dependiente. Haga clic abajo para agregar cónyuge o hijos.",
      add_dependent: "Agregar dependiente",
      dependent: "Dependiente",
      dependent_incomplete: "Complete los datos del dependiente",
      relationship: "Parentesco",
      forms_created: "formularios creados",
      roles: {
        principal: "Solicitante Principal",
        spouse: "Cónyuge",
        child: "Hijo(a)",
        parent: "Padre/Madre",
      },
      create_cta: "Crear formularios",
      created_title: "Paquete creado",
      created_description: "Los formularios a continuación fueron creados como borradores, con sus datos personales y dirección compartidos. Haga clic en Editar para completar cada uno.",
      created_success: "Formularios del paquete creados",
    },
    auth: {
      overline_login: "Entrar",
      login_title: "Acceda a su cuenta",
      login_subtitle: "Use su email y contraseña para continuar.",
      overline_register: "Registro",
      register_title: "Cree su cuenta",
      register_subtitle: "Comience a completar sus formularios con seguridad.",
      email: "Email",
      password: "Contraseña",
      name: "Nombre",
      login_cta: "Entrar",
      register_cta: "Registrarse",
      no_account: "¿Aún no tiene cuenta?",
      has_account: "¿Ya tiene cuenta?",
      welcome: "¡Bienvenido(a)!",
      password_min: "La contraseña debe tener al menos 8 caracteres.",
    },
    checklist: {
      overline: "Checklist de Evidencias",
      title: "Documentos Necesarios",
      description: "Marque cada ítem según lo reúne. Guardado automáticamente en su dispositivo.",
      progress: "Progreso",
      required_short: "obligatorios",
    },
    landing: {
      overline: "USCIS · Autoservicio",
      title_1: "Complete formularios",
      title_2: "oficiales de USCIS",
      title_3: "con seguridad.",
      subtitle:
        "Asistente paso a paso para formularios de inmigración de EE. UU. Usted proporciona los datos. Nosotros generamos el PDF. Usted revisa, firma y envía. Así de simple.",
      cta_primary: "Iniciar formulario",
      cta_secondary: "Ver mis formularios",
      how_it_works: "Cómo funciona",
      step_1_title: "1. Acepte los términos",
      step_1_desc: "Confirme que esta es una herramienta tecnológica.",
      step_2_title: "2. Complete los datos",
      step_2_desc: "Nombre, dirección, formulario deseado y campos específicos.",
      step_3_title: "3. Descargue el PDF",
      step_3_desc: "Revise cada campo, firme a mano y envíelo a USCIS.",
      not_doing_overline: "Lo que este sistema NO hace",
      not_doing_items: [
        "No evalúa elegibilidad",
        "No recomienda visas",
        "No da opinión legal",
        "No analiza probabilidades",
      ],
    },
    wizard: {
      step_consent: "Consentimiento",
      step_personal: "Datos Personales",
      step_address: "Dirección",
      step_form: "Formulario",
      step_specific: "Campos Específicos",
      step_review: "Revisión",
      progress: "Paso {current} de {total}",
    },
    consent: {
      title: "Término de Consentimiento",
      description:
        "Lea atentamente. Al continuar, declara entender que esta es una herramienta tecnológica de llenado de formularios — no un servicio legal.",
      acknowledge:
        "Entiendo que este sistema solo llena formularios con los datos que proporciono. Soy el único responsable de la veracidad, revisión, firma y envío del documento a USCIS. Este servicio NO ofrece asesoría legal, NO evalúa elegibilidad y NO sustituye a un abogado.",
      signature_label: "Firma Digital (nombre completo)",
      signature_placeholder: "Escriba su nombre completo",
      signature_help: "Al escribir su nombre confirma el consentimiento anterior.",
    },
    personal: {
      title: "Datos Personales",
      description: "Información básica de identificación.",
      family_name: "Apellido (Family Name)",
      given_name: "Nombre (Given Name)",
      middle_name: "Segundo nombre",
      date_of_birth: "Fecha de nacimiento",
      gender: "Género",
      gender_options: { MALE: "Masculino", FEMALE: "Femenino", OTHER: "Otro" },
      ssn: "Social Security Number (SSN)",
      ssn_help: "9 dígitos. Cifrado antes de almacenar.",
      a_number: "A-Number (Alien Registration)",
      a_number_help: "9 dígitos, si lo tiene.",
      email: "Correo electrónico",
      phone: "Teléfono",
    },
    address: {
      title: "Dirección",
      description: "Dirección residencial o de correspondencia.",
      street: "Dirección (calle y número)",
      apartment: "Apto/Unidad",
      city: "Ciudad",
      state: "Estado/Provincia",
      zip: "Código Postal / ZIP",
      country: "País",
    },
    form_selection: {
      title: "Seleccione el Formulario",
      description: "Elija qué formulario oficial de USCIS desea completar.",
      categories: "Categorías:",
    },
    form_specific: {
      title: "Campos Específicos",
      description: "Información específica del formulario seleccionado.",
    },
    review: {
      title: "Revisión y Validación",
      description:
        "Revise todos los datos. El sistema ejecuta una verificación técnica de completitud — no un análisis legal.",
      filled: "Campos completados",
      missing: "Campos obligatorios faltantes",
      warnings: "Advertencias técnicas",
      valid: "Todos los campos obligatorios están completos.",
      generate: "Generar PDF",
      generating: "Generando…",
    },
    success: {
      title: "PDF generado con éxito",
      description:
        "Revise cada campo del PDF antes de imprimir, firmar y enviar a USCIS. Usted es el único responsable del contenido.",
      download: "Descargar PDF",
      new_form: "Nuevo formulario",
      dashboard: "Ir al panel",
    },
    dashboard: {
      title: "Mis Formularios",
      description: "Todos los formularios completados por usted en este dispositivo.",
      empty: "Aún no hay formularios. Comience por el primero.",
      create: "Crear nuevo formulario",
      column_form: "Formulario",
      column_status: "Estado",
      column_updated: "Actualizado",
      column_actions: "Acciones",
    },
  },
  en: {
    brand: "PrimeForms",
    tagline: "USCIS · Self-Service",
    disclaimer_short: "Technological tool. Not legal advice.",
    disclaimer_long:
      "This is a purely technological form-filling system. It does NOT evaluate cases, does NOT recommend visas, and does NOT replace legal counsel. You are solely responsible for the accuracy of the information and for submitting the document.",
    nav: { home: "Home", new_form: "New Form", dashboard: "My Forms", advisor: "Which form?", pricing: "Pricing", admin: "Admin", about: "About" },
    common: {
      next: "Next", back: "Back", save: "Save", cancel: "Cancel",
      download: "Download PDF", preview: "Preview", required: "Required",
      optional: "Optional", loading: "Loading…", submit: "Generate PDF",
      review: "Review", start: "Start", draft: "Draft", completed: "Completed",
      new: "New", view: "View", edit: "Edit", delete: "Delete", confirm: "Confirm",
      draft_restored: "Draft restored", discard_draft: "Discard draft",
      autosaved: "Auto-saved", edit_ssn_hint: "SSN already stored. Leave blank to keep.",
      logout: "Sign out",
    },
    auth: {
      overline_login: "Sign in", login_title: "Access your account",
      login_subtitle: "Use your email and password to continue.",
      overline_register: "Sign up", register_title: "Create your account",
      register_subtitle: "Start filling your forms securely.",
      email: "Email", password: "Password", name: "Name",
      login_cta: "Sign in", register_cta: "Sign up",
      no_account: "No account yet?", has_account: "Already have an account?",
      welcome: "Welcome!", password_min: "Password must be at least 8 characters.",
    },
    checklist: {
      overline: "Evidence Checklist", title: "Required Documents",
      description: "Check each item as you gather it. Auto-saved on your device.",
      progress: "Progress", required_short: "required",
    },
    packages: {
      overline: "Combo Packages · USCIS",
      title: "AOS Combo Package",
      subtitle: "Create multiple related forms at once, sharing personal data and address. Fill in each form's specific fields later.",
      nav: "Packages",
      step_select: "Choose Package",
      step_select_description: "Select which combination of forms you want to create.",
      step_principal: "Principal Applicant",
      step_dependents: "Dependents",
      step_dependents_description: "Add spouse, children, or other dependents who will also have forms generated (I-485/I-765/I-131 each).",
      no_dependents: "No dependents. Click below to add spouse or children.",
      add_dependent: "Add dependent", dependent: "Dependent",
      dependent_incomplete: "Complete the dependent's data", relationship: "Relationship",
      forms_created: "forms created",
      roles: { principal: "Principal Applicant", spouse: "Spouse", child: "Child", parent: "Parent" },
      create_cta: "Create forms",
      created_title: "Package created",
      created_description: "The forms below were created as drafts, with shared personal data and address. Click Edit to complete each one.",
      created_success: "Package forms created",
    },
    landing: {
      overline: "USCIS · Self-Service",
      title_1: "Fill official",
      title_2: "USCIS forms",
      title_3: "with confidence.",
      subtitle: "Step-by-step assistant for US immigration forms. You provide the data. We generate the PDF. You review, sign, and submit. Simple.",
      cta_primary: "Start form",
      cta_secondary: "View my forms",
      how_it_works: "How it works",
      step_1_title: "1. Accept the terms",
      step_1_desc: "Confirm this is a technological tool.",
      step_2_title: "2. Fill the data",
      step_2_desc: "Name, address, chosen form, and specific fields.",
      step_3_title: "3. Download the PDF",
      step_3_desc: "Review each field, sign by hand, and submit to USCIS.",
      not_doing_overline: "What this system does NOT do",
      not_doing_items: [
        "Does not evaluate eligibility",
        "Does not recommend visas",
        "Does not give legal opinion",
        "Does not analyze chances",
      ],
    },
    wizard: {
      step_consent: "Consent", step_personal: "Personal Data",
      step_address: "Address", step_form: "Form",
      step_specific: "Specific Fields", step_review: "Review",
      progress: "Step {current} of {total}",
    },
    consent: {
      title: "Consent Statement",
      description: "Read carefully. By continuing, you acknowledge this is a technological form-filling tool — not a legal service.",
      acknowledge: "I understand this system only fills forms with the data I provide. I am solely responsible for accuracy, review, signature, and submission of the document to USCIS. This service does NOT offer legal advice, does NOT evaluate eligibility, and does NOT replace an attorney.",
      signature_label: "Digital Signature (full name)",
      signature_placeholder: "Type your full name",
      signature_help: "By typing your name you confirm the consent above.",
    },
    personal: {
      title: "Personal Data", description: "Basic identification information.",
      family_name: "Family Name (Last Name)", given_name: "Given Name (First Name)",
      middle_name: "Middle Name", date_of_birth: "Date of Birth", gender: "Gender",
      gender_options: { MALE: "Male", FEMALE: "Female", OTHER: "Other" },
      ssn: "Social Security Number (SSN)", ssn_help: "9 digits. Encrypted before storing.",
      a_number: "A-Number (Alien Registration)", a_number_help: "9 digits, if you have one.",
      email: "Email", phone: "Phone",
    },
    address: {
      title: "Address", description: "Residential or mailing address.",
      street: "Street address", apartment: "Apt/Unit", city: "City",
      state: "State/Province", zip: "ZIP / Postal Code", country: "Country",
    },
    form_selection: {
      title: "Select the Form",
      description: "Choose which official USCIS form you want to complete.",
      categories: "Categories:",
    },
    form_specific: {
      title: "Specific Fields",
      description: "Specific information for the selected form.",
    },
    review: {
      title: "Review and Validation",
      description: "Verify all data. The system runs a technical completeness check — not a legal analysis.",
      filled: "Completed fields", missing: "Required fields missing",
      warnings: "Technical warnings",
      valid: "All required fields are complete.",
      generate: "Generate PDF", generating: "Generating…",
    },
    success: {
      title: "PDF generated successfully",
      description: "Review each field on the PDF before printing, signing, and submitting to USCIS. You are solely responsible for the content.",
      download: "Download PDF", new_form: "New form", dashboard: "Go to dashboard",
    },
    dashboard: {
      title: "My Forms", description: "All forms you have completed on this device.",
      empty: "No forms yet. Start with the first one.",
      create: "Create new form", column_form: "Form", column_status: "Status",
      column_updated: "Updated", column_actions: "Actions",
    },
  },
};
